export default `<div>

    <p><strong>FutureX Founding Partner Ms. Cynthia Zhang: Investing in the GenAI Era</strong></p>

    <p>Our team just returned from Silicon Valley, and encountered a widespread misconception.: Many in the investment
        community believe Silicon Valley primarily concentrates on developing a few Large Language Models (LLMs),
        viewing China's approach as more varied. Yet, after discussions with various computing power service providers,
        we found that relatively few Chinese companies are investing in LLM development. Conversely, in Silicon Valley,
        it's apparent that nearly every major tech firm is actively engaged in building its own LLMs.</p>

    <p>We identified two significant opportunities: First, the swift advancement of Large Language Models (LLMs)
        indicates we're on the cusp of a significant surge in AI applications. In Silicon Valley, numerous enterprises
        are already leveraging cutting-edge technology to address industry challenges. Second, the areas of models and
        data are poised to generate a wealth of investment prospects.</p>

    <p>Despite a general decline in project valuations in Silicon Valley this year, the field of AI applications is
        sparking more investment interest. The caliber of entrepreneurs remains high, suggesting that timely and
        well-strategized investments could produce substantial returns. This echoes the successful investment strategies
        observed during the early days of the Mobile Internet Era, where the right timing and focus were
            key.</p>

    <p>Compared to Silicon Valley VCs, FutureX holds distinct advantages. Firstly, our insight into product innovation
        is unparalleled. Our track record demonstrates our precision in identifying and investing in companies that
        achieve over a hundred million users in China. This success stems from our profound grasp of AI technology and
        acute awareness of industry-specific challenges and demands. Furthermore, Silicon Valley entrepreneurs
        frequently seek our guidance on choosing the optimal industry for their projects. This reflects our capability
        to provide clear direction, thereby fast-tracking their ventures—a testament to our cognitive edge.</p>

    <p>Additionally, our investments, including firms like ByteDance, underscore the robust market penetration and swift
        expansion of Chinese tech companies in the US. With over ten of our portfolio tech companies establishing a
        foothold in Silicon Valley and making notable strides, the growth of our FutureX ecosystem is enhancing our and
        our partners' prospects in the US market. We've identified four key opportunity areas, highlighting our unique
        insights and strategic focus:</p>

    <p>- &nbsp;AI x Social E-Commerce: we see the US market’s rapid adoption of social in the US market following Douyin
        Shops’ huge success in China.</p>

    <p>- &nbsp;AI x Smart Device: Last year, we turned our focus towards and began investing in smart devices, including
        AI-empowered earphones. This area, gaining significant interest from Silicon Valley VCs, has revealed
        substantial opportunities.</p>

    <p>- &nbsp;AI x Social Network: We are convinced that AI, particularly in products that resonate with users'
        emotional values in social contexts, holds the potential to generate significant. commercial value.</p>

    <p>- &nbsp;AI x Vertical Domains: From travel planners to home designers, AI agents can empower a spectrum of
        industries.</p>

    <p>Drawing on our expertise and knowledge of both the Asian and US markets, we see ourselves as a bidirectional time
        traveler, focusing on investments in projects that are either technologically advanced or in their growth phase.
        Simultaneously, we keep an eye on the international market expansion for Chinese companies and the ongoing
        achievements of Chinese entrepreneurs.</p>

    <p><strong>VP of FutureX, Ms Zhitong Jiang: AI-native IT Architecture Review</strong></p>

    <p>Since 2014, the core members of the FutureX team have been strategically engaged in the ICT industry, initially
        emphasizing infrastructure development around cloud computing. With the advent of AI, there's been a swift
        adoption of applications powered by LLMs. Despite the ICT infrastructure still relying on traditional cloud
        computing, enhancements for AI integration are evident across terminals, cloud, and content production.</p>

    <p>Though many applications still use traditional architecture, an emerging AI-driven ecosystem is beginning to
        integrate with conventional frameworks. Even though there haven't been significant breakthroughs in content
        traffic gateways, we expect the rise of platforms offering more tailored content via LLMs soon.</p>

    <p>2024 may mark a pivotal year for AI Devices, aiming to enhance multi-dimensional information perception and
        gather more continuous, unstructured data. This data is processed not just at the device level but also uploaded
        to the cloud for smarter applications. Currently, most AI device products are still in the demo phase, requiring
        further iterations before reaching full usability. However, we predict a shift from traditional applications to
        those driven by AI models. This transition will simplify IT architecture, moving from conventional operating
        systems to a model-driven approach. The future app ecosystem is likely to be dominated by a few universal LLMs
        alongside numerous specialized models, with data platforms for model training becoming critical infrastructure.
    </p>

    <p>The cloud architecture is also evolving, moving from a CPU-based to a GPU-led parallel processing framework. As
        application demand grows, the need for GPUs will surpass just training needs, merging the roles of cloud
        providers and GPU manufacturers. Major cloud firms are now developing their own GPUs and TPUs, with companies
        like Nvidia expanding into cloud services. This move towards offering comprehensive AI services, including
        computational power and models, highlights a significant industry trend.</p>

    <p>Hence, we see several clear opportunities in AI-empowered social commerce, AI smart devices, AI x vertical
        domain, and AI x social networks.</p>

    <p><strong>Opportunity 1 – Smart Device</strong></p>

    <p>Leveraging AI through software updates in existing devices is sparking new business models. For example, several
        automakers have embedded GPT technology into their voice assistance and interaction systems, paving the way for
        service providers to offer intelligent enhancements to traditional manufacturers. At CES, AI personal computers
        (AIPCs) showcased by leading brands like Lenovo and Samsung stood out. These AIPCs, equipped with upgraded CPUs
        and GPUs, manage basic content creation tasks on their own, while their software integrates seamlessly with
        Windows OS features. In enhancing user interaction, many opt for streamlined operations, like using shortcut
        keys to refine the AI experience, making it more intuitive.</p>

    <p>Another emerging trend involves startups like Rabbit R1, which aspire to redefine human-device interaction,
        aiming to replace traditional smartphones. Yet, in terms of user experience and functionality, these innovations
        haven't quite met the benchmark set by established consumer products.</p>

    <p><strong>Opportunity 2 – Rise of Social Commerce</strong></p>

    <p>Chinese companies like Temu and TikTok are reshaping the traditional business landscape in the U.S. The shift in
        e-commerce from standalone platforms to integrated ecosystems that blend content, advertising, and sales is a
        significant trend.</p>

    <p>To support this evolving ecosystem, there's a need for service providers specializing in content and data
        analysis to help create a self-sustaining loop. This transformation opens up opportunities for businesses
        engaged in international e-commerce, content production, and data analytics.</p>
    <p><strong>Opportunity 3 - New Generation Content/Social Networks</strong></p>

    <p>In the GenAI era, we anticipate significant opportunities to fulfill core human needs such as emotional
        satisfaction and self-realization. Progress in AI companionship and metaverse software/hardware signals a
        transformative new phase for social and content platforms.</p>

    <p><strong>Opportunity 4 - Vertical Domain Applications</strong></p>

    <p>The fusion of AI technology with specialized domain knowledge and data is poised to enhance value across various
        industry verticals.</p>

    
</div>`;
